import { Drawer } from 'antd';
import { useEffect, useState } from 'react';
import saveAs from 'file-saver';
import PDFViewModal2 from '../../components/expenses/PDFViewModal2';
import TaxInvoiceDetailComponent from '../../components/invoices/TaxInvoiceDetailComponent';
import TaxInvoiceEditDrawer from './TaxInvoiceEditDrawer';
import { deleteTaxInvoice } from '../../api/constlink';

interface TaxInvoiceDetailDrawerProps {
  config: any;
  visible: boolean;
  onClose: (isTaxInvoiceChanged: boolean) => void;
}

function TaxInvoiceDetailDrawer({
  config,
  visible,
  onClose,
}: TaxInvoiceDetailDrawerProps) {
  const [editDrawerConfig, setEditDrawerConfig] = useState<any>(null);
  const [taxInvoice, setTaxInvoice] = useState<any>(null);
  const [pdfFile, setPdfFile] = useState<any>();
  const [isTaxInvoiceChanged, setIsTaxInvoiceChanged] = useState(false);

  useEffect(() => {
    if (config) {
      setTaxInvoice(config.taxInvoice);
    }
  }, [config]);

  const moveToEditPage = () => {
    setEditDrawerConfig({ ...config });
  };

  const onCloseEditDrawer = (updatedTaxInvoice: any) => {
    setEditDrawerConfig(null);
    if (updatedTaxInvoice) {
      setTaxInvoice(updatedTaxInvoice);
      setIsTaxInvoiceChanged(true);
    }
  };

  const _downloadReceipt = () => {
    saveAs(pdfFile.url, `${pdfFile.name}`);
  };

  const openPdfFile = (file: any) => {
    setPdfFile(file);
  };

  const _deleteTaxInvoice = async (taxInvoiceId: number) => {
    const _totalConnectedInvoicePrice = config.taxInvoice.invoices.reduce(
      (acc: number, cur: any) => acc + cur.price,
      0,
    );
    if (_totalConnectedInvoicePrice !== 0) {
      alert(
        '매입증빙을 삭제할 수 없습니다. 연결된 청구서를 먼저 해제해 주세요.',
      );
      return;
    }

    await deleteTaxInvoice({
      enterpriseId: config.enterpriseId,
      taxInvoiceId: config.taxInvoice.id,
    });

    onClose(true);
    alert('매입증빙이 삭제되었습니다.');
  };

  return (
    <>
      <Drawer
        width={900}
        placement="right"
        closable={false}
        onClose={() => onClose(isTaxInvoiceChanged)}
        open={visible}
      >
        {taxInvoice && (
          <TaxInvoiceDetailComponent
            taxInvoice={taxInvoice}
            moveToEditPage={moveToEditPage}
            openPdfFile={openPdfFile}
            deleteTaxInvoice={_deleteTaxInvoice}
          />
        )}
      </Drawer>
      {editDrawerConfig && (
        <TaxInvoiceEditDrawer
          config={editDrawerConfig}
          visible={editDrawerConfig !== null}
          onClose={onCloseEditDrawer}
        />
      )}
      {pdfFile && (
        <PDFViewModal2
          visible={!!pdfFile}
          url={pdfFile.url}
          onCancel={() => setPdfFile(null)}
          onDownload={_downloadReceipt}
        />
      )}
    </>
  );
}

export default TaxInvoiceDetailDrawer;
